export default [
    {
        id: 1,
        name_ca: '> 75 %',
        name_en: '> 75 %',
        name_es: '> 75 %'
    },
    {
        id: 2,
        name_ca: '> 50 %',
        name_en: '> 50 %',
        name_es: '> 50 %'
    },
    {
        id: 3,
        name_ca: '< 50 %',
        name_en: '< 50 %',
        name_es: '< 50 %'
    },
    {
        id: 4,
        name_ca: '< 25 %',
        name_en: '< 25 %',
        name_es: '< 25 %'
    }
]


// WEBPACK FOOTER //
// ./src/options/degree_types.js